import { CheckCircle2, Edit2, Trash2, XCircle } from "lucide-react";

const authUser = JSON.parse(localStorage.getItem("authUser"))?.[0];

export const initialForm = {
  id: 0,
  isoCode: "",
  locCode: "",
  description: "",
  stateName: "",
  activeFlag: true,
  modifiedDate: "",
  createdDate: "",
  country: "",
  createdBy: authUser?.firstName+" "+(authUser?.lastName || ""),
  modifiedByUser: authUser?.firstName+" "+(authUser?.lastName || ""),
};

 


  export const validationConfig = {
    country: { required: true, label: "Country ISO Code" },
    locCode: { required: true, label: "LOC Code" },
    stateName: { required: true, label: "Area Name" },
  };

 export const filterTypeOptions = [
  {
    label: "AREA NAME",
    value: "AREA_NAME",
  },
  {
    label: "LOC CODE",
    value: "LOC_CODE",
  },
  {
    label: "COUNTRY",
    value: "COUNTRY",
  },
];

export const getLocationColumns = (handlers) => {
  const { handleEdit, handleDelete } = handlers;

  return [
    {
      key: "country",
      label: "COUNTRY",
      render: (v) => v?.country || "-"
    },
    {
      key: "isoCode",
      label: "ISO CODE",
      render: (v) => v?.isoCode || "-"
    },
    {
      key: "locCode",
      label: "LOC CODE",
      render: (v) => v?.locCode || "-"
    },
    {
      key: "stateName",
      label: "AREA NAME",
      render: (v) => v?.stateName || "-"
    },
    {
      key: "status",
      label: "STATUS",
      render: (v) => (
        <div
          className={`flex items-center gap-1 text-xs font-medium ${
            v?.activeFlag ? "text-green-700" : "text-red-700"
          }`}
        >
          {v?.activeFlag ? (
            <>
              <CheckCircle2 size={14} />
              Active
            </>
          ) : (
            <>
              <XCircle size={14} />
              Inactive
            </>
          )}
        </div>
      )
    },
    {
      key: "action",
      label: "ACTION",
      render: (v) => (
        <div className="flex items-center gap-3">
          <button
            onClick={() => handleEdit(v)}
                className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200 "
            title="Edit"
          >
            <Edit2 size={16} />
          </button>

          <button
            onClick={() => handleDelete(v)}
                        className="w-6 h-6 rounded flex items-center justify-center transition-all bg-red-100 text-red-700 hover:bg-red-200 "
            title="Delete"
          >
            <Trash2 size={16} />
          </button>
        </div>
      )
    }
  ];
};